import { Card } from '../../../../common/Card';
import { Icon } from '../../../../common/Icon';

interface AnalyticsCardProps {
  title: string;
  percentage: number;
  trend?: number;
}

export function AnalyticsCard({
  title,
  percentage,
  trend,
}: AnalyticsCardProps): JSX.Element {
  const isPositiveTrend = (trend || 0) > 0;
  const trendText = `${Math.round(Math.abs(trend || 0))}%`;

  return (
    <Card className="flex flex-col flex-1  px-5 py-3 gap-2">
      <div className="text-sm font-[400] text-[#141414]">{title}</div>
      <div className="flex items-baseline gap-2">
        <span className="text-2xl font-medium text-black">{percentage}%</span>
        {!!trend && (
          <div className="flex items-center gap-1 text-sm">
            {isPositiveTrend ? (
              <Icon name="arrowup" className="h-4 w-4 text-green-500" />
            ) : (
              <Icon name="arrowdown" className="h-4 w-4 text-red-500" />
            )}
            <span
              className={`line-clamp-1 ${
                isPositiveTrend ? 'text-green-500' : 'text-red-500'
              }`}
            >
              {trendText}
            </span>
          </div>
        )}
      </div>
    </Card>
  );
}
